export const SUCCESS_STATUS_AUTH_USER = 'The operation was successful'
export const FAIL_STATUS_AUTH_USER = 'Your gmail email does not match with account email'



// WEBPACK FOOTER //
// ./src/constants/googleApi/statusAuthUserServer.js